import { data } from '../../svg/Hand/data';
import { makeIcon } from '../makeIcon';

export const Hand = makeIcon(data, 'hand', 'Hand');

export default Hand;
